import { render } from "./login_phone.vue?vue&type=template&id=36a68c6f&scoped=true&ts=true"
import script from "./login_phone.vue?vue&type=script&lang=ts"
export * from "./login_phone.vue?vue&type=script&lang=ts"

import "@/style/common.less?vue&type=style&index=0&id=36a68c6f&scoped=true&lang=less&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a68c6f"]])

export default __exports__